import './Features.css';

const FEATURES = [
  { icon:'🧪', title:'AI-Powered Test Builder', desc:'Create coding, aptitude, and domain-specific tests in minutes with AI-generated questions tailored to any role and seniority level.', tags:['AI generation','50+ domains','Custom tests'] },
  { icon:'📋', title:'Resume Library & Parsing', desc:'Every resume automatically parsed, skills extracted, and scored against the job. A searchable talent library that grows with every application.', tags:['Auto-parse','Skill graph','Searchable'] },
  { icon:'📅', title:'Interview Scheduling', desc:'Schedule interviews directly from the admin panel. Calendar sync, automated reminders, and post-interview feedback forms — all in one place.', tags:['Calendar sync','Reminders','Feedback'] },
  { icon:'📊', title:'Recruiter Analytics Dashboard', desc:'Track team performance — total recruiters, open jobs, pipeline velocity, conversion rates, and offer outcomes — with live data toggle.', tags:['Live data','Team KPIs','Conversion'] },
  { icon:'🎯', title:'Job Analytics & Hiring Funnel', desc:'Per-job hiring metrics: total applied, screened, interviewed, offered, hired, and rejected — with application source breakdown and assessment score distribution.', tags:['Per-job','Funnel','Score dist.'] },
  { icon:'🔐', title:'Role-Based Access Control', desc:'Fine-grained permissions per user role — hiring manager, recruiter, interviewer, admin. Control exactly what each person can see, edit, and action.', tags:['RBAC','Audit logs','Permissions'] },
  { icon:'🌐', title:'Candidate Career Portal', desc:'A dedicated public-facing portal where candidates browse roles, apply, take assessments, and track their pipeline status in real time.', tags:['Self-service','Real-time','Branded'] },
  { icon:'🤖', title:'AI-Assisted Shortlisting', desc:'Machine learning ranks candidates by fit score, skill match, and assessment performance — surfacing the best candidates at the top of every list.', tags:['ML ranking','Fit score','Auto-rank'] },
  { icon:'💬', title:'Application Status Tracking', desc:'Every candidate sees their status in real time. Automated email notifications at every stage keep candidates informed and your brand strong.', tags:['Transparency','Auto-email','Stage alerts'] },
];

export default function Features() {
  return (
    <section id="features" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Full Feature Set</span>
        <h2 className="sec-title">Everything hiring needs. Nothing it doesn't.</h2>
        <p className="sec-sub" style={{marginBottom:'3rem'}}>
          VERDICT replaces your ATS, your test platform, your scheduling tool, and your
          analytics sheet — with one AI-powered system that just works.
        </p>
        <div className="features-grid">
          {FEATURES.map(f => (
            <div key={f.title} className="feat-card">
              <div className="feat-card__icon">{f.icon}</div>
              <h3 className="feat-card__title">{f.title}</h3>
              <p className="feat-card__desc">{f.desc}</p>
              <div className="tags">
                {f.tags.map(t => <span key={t} className="tag">{t}</span>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
